import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { RCUtils } from './../../../RCUtils';
import $ from 'jquery';
import { PopupWindow } from '../PopupWindow';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface ACTGridState {
    SelectedReefers: any[],
    RowData: server.USP_UnitCurrentConditionUI_Model[],
    ForwardCommandParms: server.ForwardCommandParams;
    Filters: server.ACTParams,
    CmbStatus: string,
    cssClass: string,
    VisibleFinalTemp: string;
    VCCheckBoxInfo: VCCheckBoxData; 
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}
var self;
var USDACeilingText;
var ACTPostACTSetpointText;
var tempFormat; //WI26490 Celsius or Fahrenheit indication 
export class AutomaticColdTreatment extends React.Component<any, ACTGridState> {
    constructor(props: any) {
        super(props);
        self = this;
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        var forwardCommandParms: server.ForwardCommandParams = { SelectedReefers: [], CommandName: null, TempValue: null, PreTripCmdFilters: null, TraditionalDownload: null, lstAutoConfigParams: null, IsCmdSendViaVC: null, VesselInfo:null };
        this.state = { SelectedReefers: [], RowData: [], ForwardCommandParms: forwardCommandParms, Filters: filterSet, CmbStatus: 'ON', cssClass: 'show', VisibleFinalTemp: 'hidden', VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [] };
        tempFormat = this.GetTempColumnFormatter(); //WI26490 Celsius or Fahrenheit indication 
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderACTGrid(this.props.reeferData);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }

    componentWillReceiveProps(nextprops: any) {
        this.setState({ SelectedReefers: reeferData });
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderACTGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderACTGrid(reeferData: any) {
        this.setState({ SelectedReefers: reeferData });
        var filterSet = this.setDefaultFilters();
        this.setState({ Filters: filterSet });
        this.state.ForwardCommandParms.CommandName = "AutomaticColdTreatment";
        this.state.ForwardCommandParms.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData });
        var forwardCommandParams = JSON.stringify(this.state.ForwardCommandParms);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
        var reeferOEMTypeCd = reeferData[0].ReeferOEMTypeCd.trim();
        if (reeferOEMTypeCd == "S") {
            USDACeilingText = "Max USDA Temp " + tempFormat + " :";
            ACTPostACTSetpointText = "ACT Setpoint " + tempFormat + " :";
            this.setState({ VisibleFinalTemp: '' });


        } else if (reeferOEMTypeCd == "C") {
            USDACeilingText = "Ceiling Temp. " + tempFormat + " :";
            ACTPostACTSetpointText = "Post ACT Setpoint " + tempFormat + " :";
            this.setState({ VisibleFinalTemp: 'hidden' });
        }

    }

    StatusChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        if (Value == 'ON') {
            this.setState({cssClass:'show'})
        }
        else {
            this.setState({ cssClass: 'hidden' })
        }
        var filters = this.state.Filters;
        this.state.Filters.ACTTurnONoFF = Value;
        this.setState({ Filters: filters });
        this.setState({ CmbStatus: Value });
    }
    ACTDurationChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var ACTDurationVal = this.state.Filters.ACTDuration;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            ACTDurationVal = Value;
        else
            return;
        this.state.Filters.ACTDuration = ACTDurationVal;
        this.setState({ Filters: filters });
    }
    USDATempChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var USDATempVal = this.state.Filters.USDATemp;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            USDATempVal = Value;
        else
            return;
        this.state.Filters.USDATemp = USDATempVal;
        this.setState({ Filters: filters });
    }
    ACTSetpointChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var ACTSetpointVal = this.state.Filters.ACTSetpoint;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            ACTSetpointVal = Value;
        else
            return;
        this.state.Filters.ACTSetpoint = ACTSetpointVal;
        this.setState({ Filters: filters });
    }
    ACTTempChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var ACTTempVal = this.state.Filters.ACTTemp;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            ACTTempVal = Value;
        else
            return;
        this.state.Filters.ACTTemp = ACTTempVal;
        this.setState({ Filters: filters });
    }


    setDefaultFilters() {
        var filters: server.ACTParams = {
            ACTTurnONoFF: 'ON',ACTDuration: '', ACTSetpoint: '', ACTTemp: '', USDATemp: '' 
        };
        return filters;
    }

    ValidateNumberValue(param) {
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }

    ValidateDecimalValue(param) {
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }

    //WI26490 Celsius or Fahrenheit indication 
    GetTempColumnFormatter() {
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (tempUnitCd.toUpperCase() == "F")
            return "(°F)";
        else
            return "(°C)";
    }

    submitACTCommand() {
        if (this.state.Filters.ACTTurnONoFF == "ON") {
            var AlertMessage = "";
            var ACTDurationValue = this.state.Filters.ACTDuration.toString();

            if ((!ACTDurationValue || ACTDurationValue == undefined || ACTDurationValue == "" || ACTDurationValue.length == 0) || !this.ValidateNumberValue(ACTDurationValue))
                AlertMessage += "Please enter valid ACT Duration. \n";
            var USDATempValue = this.state.Filters.USDATemp.toString();
            var ACTSetpointValue = this.state.Filters.ACTSetpoint.toString();
            if (this.props.reeferData[0].ReeferOEMTypeCd.trim()== "C") {
                if ((!USDATempValue || USDATempValue == undefined || USDATempValue == "" || USDATempValue.length == 0) || !this.ValidateDecimalValue(USDATempValue))
                    AlertMessage += "Please enter valid ceiling temp value. \n";

                if ((!ACTSetpointValue || ACTSetpointValue == undefined || ACTSetpointValue == "" || ACTSetpointValue.length == 0) || !this.ValidateDecimalValue(ACTSetpointValue))
                    AlertMessage += "Please enter valid post ACT setpoint value. \n";
            }
            else {
                if ((!USDATempValue || USDATempValue == undefined || USDATempValue == "" || USDATempValue.length == 0) || !this.ValidateDecimalValue(USDATempValue))
                    AlertMessage += "Please enter valid Max USDA temp value. \n";

                if ((!ACTSetpointValue || ACTSetpointValue == undefined || ACTSetpointValue == "" || ACTSetpointValue.length == 0) || !this.ValidateDecimalValue(ACTSetpointValue))
                    AlertMessage += "Please enter valid ACT setpoint value. \n";
            }

            if (this.props.reeferData[0].ReeferOEMTypeCd.trim() == "S") {
                var ACTTempValue = this.state.Filters.ACTTemp.toString();
                if ((!ACTTempValue || ACTTempValue == undefined || ACTTempValue == "" || ACTTempValue.length == 0) || !this.ValidateDecimalValue(ACTTempValue))
                    AlertMessage += "Please enter valid Final ACT Temp value.\n";
                else if (parseFloat(this.state.Filters.ACTTemp.toString()) <= parseFloat(this.state.Filters.ACTSetpoint.toString()))
                    AlertMessage += "Final ACT temp value should be greater than ACT set Point Value.\n";

                //WI26374 Bug Valid range for Final ACT Temp is - 1.5°C to + 30.0°C
                //WI26373 Bug Valid range for ACT Setpoint is - 4.9°C to[Max USDA Temp - 0.2C]
                //WI26372 Bug Valid range for Max USDA Temp is - 4.7°C to + 30.0°C.
                if (AlertMessage == '') {
                    var USDATemp = parseFloat(this.state.Filters.USDATemp.toString());
                    var ACTSetpoint = parseFloat(this.state.Filters.ACTSetpoint.toString());
                    var ACTTemp = parseFloat(this.state.Filters.ACTTemp.toString());

                    var MinUSDATemp = -4.7; var MaxUSDATemp = 30;
                    var MinActSetpoint = -4.9; var MaxActSetpoint = USDATemp - 0.2;
                    var MinActTemp = -1.5; var MaxActTemp = 30;

                    var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
                    var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
                    if (tempUnitCd.toUpperCase() == "F") {
                        MinUSDATemp = ((MinUSDATemp * 9) / 5) + 32;
                        MinUSDATemp = parseFloat(MinUSDATemp.toString());
                        MinUSDATemp = parseFloat(MinUSDATemp.toFixed(parseInt(tempRoundingValue)));

                        MaxUSDATemp = ((MaxUSDATemp * 9) / 5) + 32;
                        MaxUSDATemp = parseFloat(MaxUSDATemp.toString());
                        MaxUSDATemp = parseFloat(MaxUSDATemp.toFixed(parseInt(tempRoundingValue)));

                        MinActSetpoint = ((MinActSetpoint * 9) / 5) + 32;
                        MinActSetpoint = parseFloat(MinActSetpoint.toString());
                        MinActSetpoint = parseFloat(MinActSetpoint.toFixed(parseInt(tempRoundingValue)));

                        MaxActSetpoint = (USDATemp - 32) * 5 / 9;;
                        MaxActSetpoint = parseFloat(MaxActSetpoint.toString());                        
                        MaxActSetpoint = MaxActSetpoint - 0.2;
                        MaxActSetpoint = parseFloat(MaxActSetpoint.toFixed(parseInt(tempRoundingValue)));

                        MaxActSetpoint = ((MaxActSetpoint * 9) / 5) + 32;
                        MaxActSetpoint = parseFloat(MaxActSetpoint.toString());
                        MaxActSetpoint = parseFloat(MaxActSetpoint.toFixed(parseInt(tempRoundingValue)));

                        MinActTemp = ((MinActTemp * 9) / 5) + 32;
                        MinActTemp = parseFloat(MinActTemp.toString());
                        MinActTemp = parseFloat(MinActTemp.toFixed(parseInt(tempRoundingValue)));

                        MaxActTemp = ((MaxActTemp * 9) / 5) + 32;
                        MaxActTemp = parseFloat(MaxActTemp.toString());  
                        MaxActTemp = parseFloat(MaxActTemp.toFixed(parseInt(tempRoundingValue)));
                    }                    

                    if (USDATemp < MinUSDATemp || USDATemp > MaxUSDATemp) {
                        PopupWindow.showErrorMessage("Alert", "Max USDA Temp value should be with in range " + MinUSDATemp + " to " + MaxUSDATemp); return;
                    }
                    if (ACTSetpoint < MinActSetpoint || ACTSetpoint > MaxActSetpoint) {
                        PopupWindow.showErrorMessage("Alert", "ACT Setpoint value should be with in range " + MinActSetpoint + " to " + MaxActSetpoint); return;
                    }
                    if (ACTTemp < MinActTemp || ACTTemp > MaxActTemp) {
                        PopupWindow.showErrorMessage("Alert", "Final ACT Temp value should be with in range " + MinActTemp + " to " + MaxActTemp); return;
                    }
                }
            }            

            if (AlertMessage == '') {
                try {
                    var command = "AutomaticColdTreatment";
                    var refreshGrid = this.props.refreshGrid;
                    var paramValue = this.state.Filters.ACTTurnONoFF.toString() + ',' + this.state.Filters.ACTDuration.toString() + ',' + this.state.Filters.USDATemp.toString() + ',' + this.state.Filters.ACTSetpoint.toString() + ',' + this.state.Filters.ACTTemp.toString();
                    this.submitTemperatureCommands(command, paramValue, refreshGrid);
                }
                catch (e) {
                    PopupWindow.showErrorMessage('Error', '');
                }
            }
            else {
                PopupWindow.showErrorMessage('Error', AlertMessage);
            }
        }
        else {
            try {
                var command = "AutomaticColdTreatment";
                var refreshGrid = this.props.refreshGrid;
                var paramValue = this.state.Filters.ACTTurnONoFF.toString();
                this.submitTemperatureCommands(command, paramValue, refreshGrid);
            }
            catch (e) {
                PopupWindow.showErrorMessage('Error', AlertMessage);
            }
        }

    }

    submitTemperatureCommands(commandName, paramValue, refreshGrid) {
        if (self.state.RowData.length > 0) {
            self.state.ForwardCommandParms.CommandName = commandName;
            self.state.ForwardCommandParms.SelectedReefers = self.state.RowData;
            self.state.ForwardCommandParms.TempValue = paramValue;
            var forwardCommandParams = JSON.stringify(self.state.ForwardCommandParms);
            ReeferCommandsGrid.submitTemperatureCommands(commandName, paramValue, refreshGrid);
            this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
        return <div>
            <div className="well">
                <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-4'>
                        <span className='float-end col-form-label'>ACT Turn On/Off :</span>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-2'>
                        <select className='form-select' id='cmbStatus' onChange={e => this.StatusChange(e)} value={this.state.Filters.ACTTurnONoFF}>
                        <option key="ON">ON</option>
                        <option key="OFF">OFF</option>
                        </select>
                    </div>                
                </div>
                <div className={this.state.cssClass}>
                    <div className='row mt-2 '>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-4'>
                            <span className='float-end col-form-label'>ACT Duration (Day(s)) :</span>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.ACTDurationChange(e)} value={this.state.Filters.ACTDuration} /> </div>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-4'>
                            <span className='float-end col-form-label'>{USDACeilingText}</span>
                    </div>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.USDATempChange(e)} value={this.state.Filters.USDATemp} /> </div>
                    </div>
                    <div className='row mt-1 '>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-4'>
                            <span className='float-end col-form-label'>{ACTPostACTSetpointText}</span>
                    </div>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.ACTSetpointChange(e)} value={this.state.Filters.ACTSetpoint} /> </div>
                        <div className={this.state.VisibleFinalTemp}>
                            <div className='col-lg-3 col-md-3 col-sm-3 col-xs-4'>
                                <span className='float-end col-form-label'>Final ACT Temp {tempFormat} :</span>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-3 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.ACTTempChange(e)} value={this.state.Filters.ACTTemp} /> </div>
                         </div>
                    </div>
                    </div>
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"AutomaticColdTreatment"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitACTCommand.bind(this)}>Save</button>
             
            </div>
        </div>
    }
    
}